import APIService from 'services/APIService'

const api = APIService()

export const listPermits = bpId =>
  api.get(`/building-passport/${bpId}/permits`)

export const createPermit = (bpId, payload) =>
  api.post(`/building-passport/${bpId}/permits`, payload)

export const getPermit = (bpId, permitId) =>
  api.get(`/building-passport/${bpId}/permits/${permitId}`)

export const updatePermit = (bpId, permitId, payload) =>
  api.patch(`/building-passport/${bpId}/permits/${permitId}`, payload)

export const transitionPermit = (bpId, permitId, payload) =>
  api.post(`/building-passport/${bpId}/permits/${permitId}/transition`, payload)

export const exportPermitPdf = (bpId, permitId) =>
  api.get(`/building-passport/${bpId}/permits/${permitId}/export/pdf`, {
    responseType: 'blob'
  })

export const presignPermitRams = (bpId, payload) =>
  api.post(`/building-passport/${bpId}/permits/rams/presign`, payload)

export const attachPermitRams = (bpId, permitId, payload) =>
  api.post(`/building-passport/${bpId}/permits/${permitId}/rams`, payload)

export const downloadPermitRams = (bpId, permitId) =>
  api.get(`/building-passport/${bpId}/permits/${permitId}/rams/download`)

export const uploadPermitRamsFile = async (bpId, file) => {
  const presign = await presignPermitRams(bpId, {
    original_filename: file.name,
    mime_type: file.type || 'application/octet-stream',
    size_bytes: file.size,
  })
  const { presignedUrl, s3Key } = presign.data.data
  const put = await fetch(presignedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
    body: file,
  })
  if (!put.ok) throw new Error('Upload failed')
  return { s3Key, fileName: file.name }
}
